module.exports = __webpack_public_path__ + "img/02.e613583b.png";